import { Loader } from "lucide-react";

const NpiField = ({
  label = "NPI Number",
  name = "npi_number",
  value = "",
  onChange,
  status = "idle",
  loading = false,
  displayName = "",
  required = false
}) => {
  return (
    <div className="docpro_grid_item">
      <label className="docpro_fw_500 docpro_primary_color docpro_label_flex">
        <span>{label}</span>
        {loading ? (
          <span className="docpro_loading docpro_label_loader">
            <Loader width={16} height={16} />
          </span>
        ) : displayName ? (
          <span className="docpro_green_color docpro_fs_14 docpro_fw_600">({displayName})</span>
        ) : status === "invalid" ? (
          <span className="docpro_red_color docpro_fs_14 docpro_fw_600">(Not valid)</span>
        ) : null}
      </label>
      <div className="docpro_npi_field_container">
        <input
          type="text"
          className={`docpro_form_field size_lg ${status === "invalid" ? "docpro_border_red" : ""}`}
          name={name}
          required={required}
          onChange={onChange}
          value={value ?? ""}
          maxLength={10}
          onInput={(e) => {
            e.target.value = e.target.value.replace(/[^0-9]/g, "");
          }}
        />
        {status !== "idle" && (
          <span className={`docpro_npi_status_indicator ${status}`}>
            {status === "valid" ? "Valid" : "Invalid"}
          </span>
        )}
      </div>
    </div>
  );
};
export default NpiField;